'use client';

import { Product } from '@interface/product';
import { useAddProductHandler } from 'app/hooks/useAddProductHandler';
import { useSessionStore } from 'app/stores/globalStore';
import { Button } from 'designSystem/Buttons/Buttons';

export default function ProductSelectorButton({
  product,
  className = '',
  disableClientData = true,
}: {
  product: Product;
  className?: string;
  disableClientData?: boolean;
}) {
  const addProductHandler = useAddProductHandler({ isDashboard: false });
  const { cleanCheckoutSession } = useSessionStore(state => state);

  return (
    <Button
      onClick={() => {
        cleanCheckoutSession(disableClientData);
        addProductHandler(product);
      }}
      size="lg"
      type="primary"
      className={`mb-6 md:mb-0 md:mt-auto ${className}`}
      id="tmevent_click_book_anchor_button"
    >
      Me interesa
    </Button>
  );
}
